<template>
  <a-result status="404" title="404" sub-title="页面未找到">
    <template #extra>
      <a-space>
        <a-button @click="goHomeMeasurement">
          度量平台主页
        </a-button>
        <a-button @click="goHomeDemand">
          需求平台主页
        </a-button>
        <a-button @click="goToAiAgent">
          AI Agent
        </a-button>
        <a-button type="primary" @click="reloadPage">
          重试
        </a-button>
      </a-space>
    </template>
  </a-result>
</template>

<script>
export default {
  name: 'OpProhibited',
  methods: {
    goHomeDemand() {
      this.$router.push('/demand-platform');
    },
    goHomeMeasurement() {
      this.$router.push('/measurement-platform');
    },
    reloadPage() {
      this.$router.go(-1);
    },
    goToAiAgent() {
      window.location.href = '//aiagent.chaobangai.com';
    }
  }
};
</script>